module.exports = "/images/login-icon-psw.png?7d7a2de2b6db9cdc40b7e1dc39f04745";